import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { DocumentTagAndId } from '@app/features/documents/document.model';
import { RUNTIME_CONFIG } from '@environments/runtime-config.token';
import { Observable } from 'rxjs';
import { Contract } from '../contract.model';
import { SignatureSendFailure, YousignEvent } from './signature-request.model';

@Injectable({
  providedIn: 'root',
})
export class SignatureService {
  private httpClient = inject(HttpClient);
  private url = `${inject(RUNTIME_CONFIG).apiUrl}/signature`;

  requestYousignSignature(contractId: string): Observable<void> {
    return this.httpClient.post<void>(`${this.url}/yousign/request/${contractId}`, {});
  }

  /** Les événements Yousign du contrat : ceux de son embauche et de ses avenants. */
  yousignEvents(contractId: string): Observable<YousignEvent[]> {
    return this.httpClient.get<YousignEvent[]>(`${this.url}/yousign/request/${contractId}`);
  }

  /** Les envois en signature échoués du contrat : ceux de son embauche et de ses avenants. */
  sendFailures(contractId: string): Observable<SignatureSendFailure[]> {
    return this.httpClient.get<SignatureSendFailure[]>(`${this.url}/send-failures/${contractId}`);
  }

  sign(contractId: string, tagAndId: DocumentTagAndId): Observable<Contract> {
    return this.httpClient.put<Contract>(
      `${this.url}/document/signed-contract/${contractId}`,
      tagAndId,
    );
  }
}
